<!-- <div class="content-cell">
    <div  class="cell-content tabset-container" kvTabSetBackground>
        <nb-tabset fullWidth>
            <nb-tab tabTitle="Left">
                <kve-top-left></kve-top-left>
            </nb-tab>
            <nb-tab tabTitle="Center">
                <kve-top-center></kve-top-center>
            </nb-tab>
            <nb-tab tabTitle="Right">
                <kve-top-right></kve-top-right>
            </nb-tab>
        </nb-tabset>
    </div>
</div -->
<nb-tabset fullWidth>
    <nb-tab tabTitle="Theme">
        <div>
            <ngx-header-theme [headerType]="headerType"></ngx-header-theme>
        </div>
    </nb-tab>
    <nb-tab tabTitle="Lft">
        <kve-top-left></kve-top-left>
    </nb-tab>
    <nb-tab tabTitle="Ctr">
        <kve-top-center></kve-top-center>
    </nb-tab>
    <nb-tab tabTitle="Rgt">
        <kve-top-right></kve-top-right>
    </nb-tab>
    
</nb-tabset>

